import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { link, toVw, toVwTablet, toVwMobile } from '../../../utils/styles';
import BigText from '../../../components/BigText';
import Cols from './AboutCols';
import Collapse from '../../../components/Collapse';
import mq from '@/utils/media-queries';

const COLLAPSE_BUTTON_TEXT_OPENED = 'Скрыть';
const COLLAPSE_BUTTON_TEXT_CLOSED = 'Полный список';

const Preface = styled(BigText)`
  margin-bottom: ${toVw(60)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(50)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(50)};
    font-size: ${toVwMobile(44)};
  `)};
`;

const Button = styled.div`
  ${link};
`;

const Category = styled.div`
  color: ${props => props.theme.colorMinor};
  margin-bottom: ${toVw(18)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(18)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(18)};
  `)};
`;

const GROUP_MARGIN_BOTTOM = 70;
const GROUP_MARGIN_BOTTOM_MD = 132;
const GROUP_MARGIN_BOTTOM_SM = 102;
const GROUPS_PADDING_TOP = 144;

const ClientGroups = styled.div`
  padding-top: ${toVw(GROUPS_PADDING_TOP)};
  margin-bottom: ${toVw(-GROUP_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    padding-top: ${toVwTablet(GROUPS_PADDING_TOP)};
    margin-bottom: ${toVwTablet(-GROUP_MARGIN_BOTTOM_MD)};
  `)};

  ${mq.mobile(css`
    padding-top: ${toVwMobile(GROUPS_PADDING_TOP)};
    margin-bottom: ${toVwMobile(-GROUP_MARGIN_BOTTOM_SM)};
  `)};
`;

const ClientGroup = styled.div`
  margin-bottom: ${toVw(GROUP_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(GROUP_MARGIN_BOTTOM_MD)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(GROUP_MARGIN_BOTTOM_SM)};
  `)};
`;

class Clients extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.array.isRequired,
  };

  state = {
    collapseButtonText: COLLAPSE_BUTTON_TEXT_CLOSED,
  };

  handleCollapseChange(opened) {
    const newButtonText = opened ? COLLAPSE_BUTTON_TEXT_OPENED : COLLAPSE_BUTTON_TEXT_CLOSED;
    this.setState({ collapseButtonText: newButtonText });
  }

  render() {
    const { items } = this.props;

    return (
      <div className={this.props.className}>
        <Preface>
          Наши клиенты: Netflix, Reckitt Benckiser, ZTE, Правительство России, ТНТ, Porsche,  Алексей Кудрин, Philip Morris, Татнефть, O1 Properties, Lotte Plaza, Fulton, Pal Zileri, Эталон-Инвест.
        </Preface>
        <Collapse onChange={opened => this.handleCollapseChange(opened)}>
          <Collapse.Trigger>
            <Button color="#fff" data-test="clients-trigger">
              {this.state.collapseButtonText}
            </Button>
          </Collapse.Trigger>
          <Collapse.Content>
            <ClientGroups>
              <Cols>
                {items.map((item, index) => (
                  <Cols.Col key={index}>
                    <ClientGroup>
                      <Category>{item.category}</Category>
                      {item.items.map((client, clientIndex) => (
                        <p key={clientIndex} data-test="client">
                          {client}
                        </p>
                      ))}
                    </ClientGroup>
                  </Cols.Col>
                ))}
              </Cols>
            </ClientGroups>
          </Collapse.Content>
        </Collapse>
      </div>
    );
  }
}

export default Clients;



// WEBPACK FOOTER //
// ./src/scenes/About/components/Clients.js